import { useEffect, useRef, useState } from 'react';

type ChatWindow = Window & { leadConnector?: { chatWidget?: { openWidget: () => void } } };

export default function ChatWidget() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'ready' | 'error'>('idle');
  const cleanupRef = useRef<() => void>(() => {});
  useEffect(() => () => cleanupRef.current(), []);

  function openChat() {
    if (status === 'loading') return;
    const chatWindow = window as ChatWindow;
    if (chatWindow.leadConnector?.chatWidget) {
      chatWindow.leadConnector.chatWidget.openWidget();
      setStatus('ready');
      return;
    }
    setStatus('loading');
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.async = true;
    script.dataset.resourcesUrl = 'https://widgets.leadconnectorhq.com/chat-widget/loader.js';
    script.dataset.widgetId = '6ac563a3f1d59457343e320f';
    script.dataset.source = 'WEB_USER';
    const cleanup = () => {
      clearTimeout(timeout);
      window.removeEventListener('LC_chatWidgetLoaded', loaded);
      script.onerror = null;
    };
    const loaded = () => {
      if (!chatWindow.leadConnector?.chatWidget) return;
      cleanup();
      chatWindow.leadConnector.chatWidget.openWidget();
      setStatus('ready');
    };
    const failed = () => {
      cleanup();
      script.remove();
      setStatus('error');
    };
    const timeout = window.setTimeout(failed, 20000);
    cleanupRef.current = cleanup;
    script.onerror = failed;
    window.addEventListener('LC_chatWidgetLoaded', loaded);
    document.body.appendChild(script);
  }

  if (status === 'ready') return null;
  return (
    <div className="fixed bottom-5 right-5 z-[1000] flex max-w-[260px] flex-col items-end gap-2">
      {status === 'error' && <p role="status" className="rounded-lg border border-gray-200 bg-white p-3 text-sm text-brand-navy shadow-lg">Chat could not load. Try again or <a className="underline" href="tel:9033212265">call (903) 321-2265</a>.</p>}
      <button type="button" onClick={openChat} disabled={status === 'loading'} aria-busy={status === 'loading'} className="inline-flex min-h-12 items-center gap-2 rounded-full bg-brand-navy px-5 py-3 text-sm font-semibold text-white shadow-lg transition-colors hover:bg-[#374954] disabled:opacity-80">
        <svg aria-hidden="true" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5Z" /></svg>
        <span aria-live="polite">{status === 'loading' ? 'Opening chat…' : 'Chat with us'}</span>
      </button>
    </div>
  );
}
